export default __webpack_public_path__ + "static/media/banner.4190b1e5.png";